import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as SearchBooksActions from 'rebook/apps/search/actions/SearchBooksActions';
import BookList from 'rebook/apps/books/components/BookList';
import ContextPagination from 'rebook/apps/base/components/ContextPagination';
import BackLink from 'rebook/apps/base/components/BackLink';
import ContentNotFound from 'rebook/apps/base/components/ContentNotFound';
import pluralize from 'rebook/apps/utils/text/pluralize';

import styles from './style.scss';


class SearchBooksView extends React.Component {
  componentDidMount() {
    this.props.SearchBooksActions.fetchInitialData(this.props.location);
  }

  componentWillUnmount() {
    this.props.SearchBooksActions.resetData();
  }

  changePage(newPageNumber) {
    this.props.SearchBooksActions.fetchBook(newPageNumber);
  }

  render() {
    const {
      bookList, booksCount, query, pageNumber, lastPageNumber, isLoading,
    } = this.props.searchBooks;

    return isLoading
      ? (
        <div className="section">
          <BookList books={[...Array(4)]} />
        </div>
      )
      : bookList
        ? (
          <div className="section">
            <BackLink link={`/search/?q=${query}`} extraClassName={styles.breadCrumbs}>
              <span className="link">Все результаты</span>
            </BackLink>
            <div className="title-1">
              Все книги по запросу «{query}»
            </div>
            <small>
              {booksCount} {pluralize(booksCount, 'книга', 'книги', 'книг')}
            </small>
            <BookList books={bookList} />
            <ContextPagination
              onPageChange={(newPageNumber) => this.changePage(newPageNumber)}
              currentPage={pageNumber}
              lastPage={lastPageNumber} />
          </div>
        )
        : (
          <ContentNotFound>
            <header>К сожалению, по вашему запросу <br />ничего не найдено.</header>
            <article>
              Скорее всего, у нас нет такой книги или автора. <br />
              Попробуйте поискать что-нибудь другое.
            </article>
          </ContentNotFound>
        );
  }
}

function mapStateToProps(state) {
  return {
    searchBooks: state.searchBooks,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    SearchBooksActions: bindActionCreators(SearchBooksActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchBooksView);
